export default ({authGuard, guestGuard, adminGuard}) => [
    // Authenticated routes.
    ...authGuard([
        {
            path: '/dashboard',
            component: require('~/Layout.vue').default,
            children: [
                {
                    path: '/dashboard',
                    meta: {
                        title: 'dashboard'
                    },
                    name: 'dashboard',
                    component: require('~/pages/dashboard.vue').default,
                    props: true
                },
            ],
        },

        // Minimal component to quickly login as another user
        {
            path: '/loginas/:user',
            component: {
                props: {
                    user: {}
                },
                mounted() {
                    axios.post('/rea/login/' + this.user)
                        .then(async (data) => {
                            // Save the token.
                            this.$store.dispatch('saveToken', {
                                token: data.data,
                            });

                            // Fetch the user.
                            await this.$store.dispatch('fetchUser');

                            // Redirect home.
                            this.$router.push({
                                name: 'dashboard'
                            })
                        })
                }
            },
            props: true,
        }
    ]),

    // Guest routes.
    ...guestGuard([
        {
            path: '/',
            meta: {
                title: 'login',
            },
            name: 'login',
            component: require('~/pages/auth/login.vue').default,
        },
        {
            path: '/password/reset',
            meta: {
                title: 'password_reset',
            },
            name: 'password.reset',
            component: require('~/pages/auth/forgotpassword.vue').default,
        },
        {
            path: '/password/reset/:token',
            meta: {
                title: 'password_reset',
            },
            name: 'password.reset.token',
            component: require('~/pages/auth/reset.vue').default,
        },
        {
            path: '/login/verify',
            meta: {
                title: 'login_otp_title',
            },
            name: 'login.verify',
            component: require('~/pages/auth/verify-otp.vue').default,
        },
    ]),

    // admin routes.
    ...adminGuard([
        {
            path: '/admin/dashboard',
            component: require('~/Layout.vue').default,
            children: [
                // Invoices
                {
                    path: '/admin/invoices',
                    meta: {
                        permission: ['index-sales-invoices', 'index-buy-invoices'],
                        title: 'invoices',
                    },
                    name: 'admin.invoices.index',
                    component: require('~/pages/admin/invoice/index.vue').default,
                },

                // Reports
                {
                    path: '/admin/reports',
                    meta: {
                        permission: 'index-reports',
                        title: 'reports',
                    },
                    name: 'admin.reports.index',
                    component: require('~/pages/admin/reports/index.vue').default,
                },
                {
                    path: '/admin/reports/resultaten-new',
                    meta: {
                        title: 'reports',
                    },
                    name: 'admin.reports.coach-new',
                    component: require('~/pages/admin/reports/results-new.vue').default,
                },
                {
                    path: '/admin/reports/coach-capacity',
                    meta: {
                        title: 'results_coach_capacity',
                    },
                    name: 'admin.reports.coach-capacity',
                    component: require('~/pages/admin/reports/coach-capacity.vue').default,
                },
                {
                    path: '/admin/reports/enrolments-timelogs',
                    meta: {
                        title: 'results_enrolments_timelogs',
                    },
                    name: 'admin.reports.enrolments-timelogs',
                    component: require('~/pages/admin/reports/enrolments-timelogs.vue').default,
                },
                {
                    path: '/admin/reports/coach-rebates',
                    meta: {
                        permission: ['view-reports', 'index-reports'],
                        title: 'reports',
                    },
                    name: 'admin.reports.coach_rebates',
                    component: require('~/pages/admin/reports/coach-rebates.vue').default,
                },
                {
                    path: '/admin/reports/bow-export',
                    meta: {
                        permission: 'view-reports',
                        title: 'reports',
                    },
                    name: 'admin.reports.bow-export',
                    component: require('~/pages/admin/reports/bow.vue').default,
                },
                {
                    path: '/admin/reports/coach-feedback',
                    meta: {
                        permission: 'view-reports',
                        title: 'reports',
                    },
                    name: 'admin.reports.coach-feedback',
                    component: require('~/pages/admin/reports/coach-feedback.vue').default,
                },
                {
                    path: '/admin/reports/coach-feedback/:coachId',
                    meta: {
                        permission: 'view-reports',
                        title: 'reports',
                    },
                    name: 'admin.reports.selected-coach-feedback',
                    component: require('~/pages/admin/reports/selected-coach-feedback.vue').default,
                    props: true
                },

                // Feedback
                {
                    path: '/admin/feedback',
                    meta: {
                        permission: ['index-feedback'],
                        title: 'feedback',
                    },
                    name: 'admin.feedback.index',
                    component: require('~/pages/admin/feedback/index.vue').default,
                },

                // FAQ
                {
                    path: '/admin/faq',
                    meta: {
                        permission: ['index-faq'],
                        title: 'faq',
                    },
                    name: 'admin.faq.index',
                    component: require('~/pages/admin/faq/index.vue').default,
                },
                {
                    path: '/admin/faq/create',
                    meta: {
                        permission: ['create-faq'],
                        title: 'faq',
                    },
                    name: 'admin.faq.create',
                    component: require('~/pages/admin/faq/create.vue').default,
                },
                {
                    path: '/admin/faq/:id/edit',
                    meta: {
                        permission: ['update-faq'],
                        title: 'faq',
                    },
                    name: 'admin.faq.edit',
                    component: require('~/pages/admin/faq/edit.vue').default,
                    props: true
                },
                {
                    path: '/admin/faq/:id',
                    meta: {
                        permission: ['view-faq'],
                        title: 'faq',
                    },
                    name: 'admin.faq.view',
                    component: require('~/pages/admin/faq/show.vue').default,
                    props: true
                },

                // Organisations routes
                {
                    path: '/admin/organisations',
                    meta: {
                        permission: 'view-organisations',
                        title: 'organisations',
                    },
                    name: 'admin.organisations.index',
                    component: require('~/pages/admin/organisation/index.vue').default,
                },
                {
                    path: '/admin/organisations/create',
                    meta: {
                        permission: 'create-organisations',
                        title: 'organisations',
                    },
                    name: 'admin.organisations.create',
                    component: require('~/pages/admin/organisation/create.vue').default,
                },
                {
                    path: '/admin/organisations/create/:type/relation/:relationId',
                    meta: {
                        permission: 'create-organisations',
                        title: 'organisations',
                    },
                    name: 'admin.organisations.create.candidate',
                    component: require('~/pages/admin/organisation/create.vue').default,
                    props: true
                },
                {
                    path: '/admin/organisations/:id/edit',
                    meta: {
                        permission: 'update-organisations',
                        title: 'organisations',
                    },
                    name: 'admin.organisations.edit',
                    component: require('~/pages/admin/organisation/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/organisations/:id',
                    meta: {
                        permission: 'view-organisations',
                        title: 'organisations',
                    },
                    name: 'admin.organisations.view',
                    component: require('~/pages/admin/organisation/show.vue').default,
                    props: true,
                },

                // Create relation under organisation
                {
                    path: '/admin/organisations/:organisationId/relations/create',
                    meta: {
                        permission: 'create-relations',
                        title: 'relations',
                    },
                    name: 'admin.organisations.relations.create',
                    component: require('~/pages/admin/organisation/relation/create.vue').default,
                    props: true,
                },

                //Relation routes
                {
                    path: '/admin/relations',
                    meta: {
                        permission: 'view-relations',
                        title: 'relations',
                    },
                    name: 'admin.relations.index',
                    component: require('~/pages/admin/relation/index.vue').default,
                },
                {
                    path: '/admin/relations/create',
                    meta: {
                        permission: 'create-relations',
                        title: 'relations',
                    },
                    name: 'admin.relations.create',
                    component: require('~/pages/admin/relation/create.vue').default,
                },
                {
                    path: '/admin/relations/:id/edit',
                    meta: {
                        permission: ['update-relations', 'update-relations-basic'],
                        title: 'relations',
                    },
                    name: 'admin.relations.edit',
                    component: require('~/pages/admin/relation/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/relations/:id',
                    meta: {
                        permission: 'view-relations',
                        title: 'relations',
                    },
                    name: 'admin.relations.view',
                    component: require('~/pages/admin/relation/show.vue').default,
                    props: true,
                },
                {
                    path: '/admin/relations/:relationId/logs/:logId/edit',
                    meta: {
                        permission: ['update-relations', 'update-relations-basic'],
                        title: 'logs',
                    },
                    name: 'admin.relations.logs.edit',
                    component: require('~/pages/admin/relation/logs/edit.vue').default,
                    props: true
                },
                {
                    path: '/admin/organisations/:organisationId/logs/:logId/edit',
                    meta: {
                        permission: ['update-relations', 'update-relations-basic'],
                        title: 'logs',
                    },
                    name: 'admin.organisations.logs.edit',
                    component: require('~/pages/admin/organisation/logs/edit.vue').default,
                    props: true
                },
                {
                    path: '/admin/relations/:relationId/logs/:logId/edit-from-coach/trajectory-enrolments/:trajectoryId/milestone-progresses/:milestoneProgressId/action-progresses/:actionProgressId/',
                    meta: {
                        permission: ['update-relations', 'update-relations-basic'],
                        title: 'logs',
                    },
                    name: 'admin.relations.logs.edit-from-coach',
                    component: require('~/pages/admin/relation/logs/edit-from-coach.vue').default,
                    props: true
                },
                {
                    path: '/admin/relations/:relationId/logs/:logId',
                    meta: {
                        title: 'log',
                    },
                    name: 'admin.relations.logs.show',
                    component: require('~/pages/admin/relation/logs/show.vue').default,
                    props: true
                },
                {
                    path: '/admin/relations/:id/candidates',
                    meta: {
                        permission: 'view-relations',
                        title: 'trajectory_manager_candidates',
                    },
                    name: 'admin.relations.view.candidates',
                    component: require('~/pages/admin/relation/candidates.vue').default,
                    props: true,
                },
                {
                    path: '/admin/relations/:id/client/candidates',
                    meta: {
                        permission: 'view-relations',
                        title: 'trajectory_manager_candidates',
                    },
                    name: 'admin.relations.view.client-candidates',
                    component: require('~/pages/admin/relation/client-candidates.vue').default,
                    props: true,
                },

                // Relation Trajectories
                {
                    path: '/admin/relations/:relationId/trajectory-enrolments/create',
                    meta: {
                        permission: 'enrol-candidates-in-trajectories',
                        title: 'enrol_candidate_to_trajectory',
                    },
                    name: 'admin.relations.trajectory-enrolments.create',
                    component: require('~/pages/admin/relation/trajectory-enrolments/create.vue').default,
                    props: true,
                },
                {
                    path: '/admin/relations/:relationId/trajectory-enrolments/:trajectoryEnrolmentId',
                    meta: {
                        title: 'candidate_enrolment',
                        permission: 'view-trajectory-enrolments',
                    },
                    name: 'admin.relations.trajectory-enrolments.view',
                    component: require('~/pages/admin/relation/trajectory-enrolments/show.vue').default,
                    props: true,
                },
                {
                    path: '/admin/relations/:relationId/trajectory-enrolments/:id/edit',
                    meta: {
                        permission: 'enrol-candidates-in-trajectories',
                        title: 'enrol_candidate_to_trajectory',
                    },
                    name: 'admin.relations.trajectory-enrolments.edit',
                    component: require('~/pages/admin/relation/trajectory-enrolments/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/relations/:relationId/trajectory-enrolments/:id/duplicate',
                    meta: {
                        permission: 'enrol-candidates-in-trajectories',
                        title: 'enrol_candidate_to_trajectory',
                    },
                    name: 'admin.relations.trajectory-enrolments.duplicate',
                    component: require('~/pages/admin/relation/trajectory-enrolments/duplicate.vue').default,
                    props: true,
                },

                // Application Activities
                {
                    path: '/admin/relations/:relationId/application-activities/:id/edit',
                    meta: {
                        title: 'application_activities',
                    },
                    name: 'admin.relations.application-activities.edit',
                    component: require('~/pages/admin/relation/application-activities/edit.vue').default,
                    props: true
                },

                // Milestone Progress routes
                {
                    path: '/admin/relations/:relationId/trajectory-enrolments/:trajectoryEnrolmentId/milestone-progresses/:milestoneProgressId',
                    meta: {
                        title: 'milestone_progress',
                    },
                    name: 'admin.relations.trajectory-enrolments.milestone-progresses.view',
                    component: require('~/pages/admin/relation/trajectory-enrolments/milestone-progresses/show.vue').default,
                    props: true,
                },

                // Action Progress document routes
                {
                    path: '/admin/relations/:relationId/trajectory-enrolments/:trajectoryEnrolmentId/milestone-progresses/:milestoneProgressId/action-progresses/:actionProgressId/action-document',
                    meta: {
                        title: 'fill_in_action_document'
                    },
                    name: 'admin.relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.update',
                    component: require('~/pages/admin/relation/trajectory-enrolments/action-document-versions/update.vue').default,
                    props: true,
                },
                {
                    path: '/admin/relations/:relationId/trajectory-enrolments/:trajectoryEnrolmentId/milestone-progresses/:milestoneProgressId/action-progresses/:actionProgressId/check/:checkId',
                    meta: {
                        title: 'inspect_action_document'
                    },
                    name: 'admin.relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.check',
                    component: require('~/pages/admin/relation/trajectory-enrolments/action-document-versions/check.vue').default,
                    props: true,
                },

                // Trajectory Project routes
                {
                    path: '/admin/projects',
                    meta: {
                        permission: 'view-trajectory-projects',
                        title: 'trajectory_projects',
                    },
                    name: 'admin.trajectory_projects.index',
                    component: require('~/pages/admin/trajectory-project/index.vue').default,
                },
                {
                    path: '/admin/projects/create',
                    meta: {
                        permission: 'create-trajectory-projects',
                        title: 'trajectory_projects',
                    },
                    name: 'admin.trajectory_projects.create',
                    component: require('~/pages/admin/trajectory-project/create.vue').default,
                },
                {
                    path: '/admin/projects/:id/edit',
                    meta: {
                        permission: 'update-trajectory-projects',
                        title: 'trajectory_projects',
                    },
                    name: 'admin.trajectory_projects.edit',
                    component: require('~/pages/admin/trajectory-project/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/projects/:id',
                    meta: {
                        permission: 'view-trajectory-projects',
                        title: 'trajectory_projects',
                    },
                    name: 'admin.trajectory_projects.view',
                    component: require('~/pages/admin/trajectory-project/show.vue').default,
                    props: true,
                },

                // Trajectories routes
                // {
                //     path: '/admin/projects/:projectId/trajectories',
                //     meta: {
                //         permission: 'view-trajectories',
                //         title: 'trajectories',
                //     },
                //     name: 'admin.trajectory_projects.trajectories.index',
                //     component: require('~/pages/admin/trajectory/index.vue').default,
                //     props: true,
                // },
                {
                    path: '/admin/projects/:projectId/trajectories/create',
                    meta: {
                        permission: 'create-trajectories',
                        title: 'trajectories',
                    },
                    name: 'admin.trajectory_projects.trajectories.create',
                    component: require('~/pages/admin/trajectory/create.vue').default,
                    props: true,
                },
                {
                    path: '/admin/projects/:projectId/trajectories/:id/edit',
                    meta: {
                        permission: 'update-trajectories',
                        title: 'trajectories',
                    },
                    name: 'admin.trajectory_projects.trajectories.edit',
                    component: require('~/pages/admin/trajectory/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/projects/:projectId/trajectories/:id',
                    meta: {
                        permission: 'view-trajectories',
                        title: 'trajectories',
                    },
                    name: 'admin.trajectory_projects.trajectories.view',
                    component: require('~/pages/admin/trajectory/show.vue').default,
                    props: true,
                },

                // Milestones routes
                // {
                //     path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones',
                //     meta: {
                //         permission: 'view-milestones',
                //         title: 'milestones',
                //     },
                //     name: 'admin.trajectory_projects.trajectories.milestones.index',
                //     component: require('~/pages/admin/milestone/index.vue').default,
                //     props: true,
                // },
                {
                    path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones/create',
                    meta: {
                        permission: 'create-milestones',
                        title: 'milestones',
                    },
                    name: 'admin.trajectory_projects.trajectories.milestones.create',
                    component: require('~/pages/admin/milestone/create.vue').default,
                    props: true,
                },
                {
                    path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones/:id/edit',
                    meta: {
                        permission: 'update-milestones',
                        title: 'milestones',
                    },
                    name: 'admin.trajectory_projects.trajectories.milestones.edit',
                    component: require('~/pages/admin/milestone/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones/:id',
                    meta: {
                        permission: 'view-milestones',
                        title: 'milestones',
                    },
                    name: 'admin.trajectory_projects.trajectories.milestones.view',
                    component: require('~/pages/admin/milestone/show.vue').default,
                    props: true,
                },

                // Actions routes
                // {
                //     path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones/:milestoneId/actions',
                //     meta: {
                //         permission: 'view-actions',
                //         title: 'actions',
                //     },
                //     name: 'admin.trajectory_projects.trajectories.milestones.actions.index',
                //     component: require('~/pages/admin/action/index.vue').default,
                //     props: true,
                // },
                {
                    path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones/:milestoneId/actions/create',
                    meta: {
                        permission: 'create-actions',
                        title: 'actions',
                    },
                    name: 'admin.trajectory_projects.trajectories.milestones.actions.create',
                    component: require('~/pages/admin/action/create.vue').default,
                    props: true,
                },
                {
                    path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones/:milestoneId/actions/:id/edit',
                    meta: {
                        permission: 'update-actions',
                        title: 'actions',
                    },
                    name: 'admin.trajectory_projects.trajectories.milestones.actions.edit',
                    component: require('~/pages/admin/action/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/projects/:projectId/trajectories/:trajectoryId/milestones/:milestoneId/actions/:id',
                    meta: {
                        permission: 'view-actions',
                        title: 'actions',
                    },
                    name: 'admin.trajectory_projects.trajectories.milestones.actions.view',
                    component: require('~/pages/admin/action/show.vue').default,
                    props: true,
                },

                // Action documents routes
                {
                    path: '/admin/action-documents',
                    meta: {
                        permission: 'view-action-documents',
                        title: 'action_documents',
                    },
                    name: 'admin.action-documents.index',
                    component: require('~/pages/admin/action-document/index.vue').default,
                },
                {
                    path: '/admin/action-documents/create',
                    meta: {
                        permission: 'create-action-documents',
                        title: 'action_documents',
                    },
                    name: 'admin.action-documents.create',
                    component: require('~/pages/admin/action-document/create.vue').default,
                },
                {
                    path: '/admin/action-documents/:id/edit',
                    meta: {
                        permission: 'update-action-documents',
                        title: 'action_documents',
                    },
                    name: 'admin.action-documents.edit',
                    component: require('~/pages/admin/action-document/edit.vue').default,
                    props: true,
                },
                {
                    path: '/admin/action-documents/:id',
                    meta: {
                        permission: 'view-action-documents',
                        title: 'action_documents',
                    },
                    name: 'admin.action-documents.view',
                    component: require('~/pages/admin/action-document/show.vue').default,
                    props: true,
                },

                //settings
                {
                    path: '/admin/settings',
                    meta: {
                        permission: 'view-settings',
                        title: 'settings',
                    },
                    name: 'admin.settings.index',
                    component: require('~/pages/admin/setting/index.vue').default,
                },
                {
                    path: '/admin/settings/:id/edit',
                    meta: {
                        permission: 'update-settings',
                        title: 'settings',
                    },
                    name: 'admin.settings.edit',
                    component: require('~/pages/admin/setting/edit.vue').default,
                    props: true,
                },
            ],
        },
    ]),

    {
        path: '*',
        component: require('~/pages/errors/404.vue').default,
    },

    {
        path: '/403',
        meta: {
            title: 'Unauthorized'
        },
        name: '403',
        component: require('~/pages/errors/403.vue').default,
    },
]
